(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["akwatix-welcome-popup"]) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'akwatix_welcome_15_v1';
    const initialize = () => {
      const root = document.querySelector('[data-akwatix-welcome]');
      if (!root || root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      const dialog = root.querySelector('dialog');
      const teaser = root.querySelector('[data-aw-open]');
      if (!dialog || !teaser || typeof dialog.showModal !== 'function') return;
      const result = root.querySelector('[data-aw-result]');
      const preview = new URLSearchParams(window.location.search).get('akwatix_popup') === 'preview';
      const designMode = root.dataset.designMode === 'true';
      const submittedHere = window.location.hash === '#AkwatixWelcomeForm';
      let memory = {};
      let timer;
      let retries = 0;
      let wasAutoOpened = false;
      try { memory = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {}; } catch (_) { memory = {}; }
      const remember = (value) => {
        memory = { ...memory, ...value };
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(memory)); } catch (_) {}
      };
      if (result?.dataset.awResult === 'success') remember({ subscribed: true });
      const subscribed = root.dataset.customerSubscribed === 'true' || memory.subscribed === true;
      if (subscribed && !preview && !designMode && !(submittedHere && result)) return;
      const otherModalOpen = () => {
        const candidates = document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .drawer.active');
        return Array.from(candidates).some(element => {
          if (element === dialog || element.getClientRects().length === 0) return false;
          const style = getComputedStyle(element);
          const bounds = element.getBoundingClientRect();
          return style.visibility !== 'hidden' && Number(style.opacity) > 0 && bounds.width > 4 && bounds.height > 4 && bounds.bottom > 0 && bounds.right > 0 && bounds.top < innerHeight && bounds.left < innerWidth;
        });
      };
      const open = (manual = false) => {
        if (!root.isConnected || dialog.open || otherModalOpen()) return false;
        if (!manual && document.visibilityState !== 'visible') return false;
        dialog.showModal();
        document.documentElement.classList.add('aw-is-open');
        teaser.hidden = true;
        if (submittedHere && result?.dataset.awResult === 'error') root.querySelector('input[type="email"]')?.focus();
        return true;
      };
      const dismiss = () => {
        const days = Number(root.dataset.dismissDays) || 14;
        remember({ dismissedUntil: Date.now() + days * 86400000 });
        clearTimeout(timer);
        dialog.close();
      };
      const onClose = () => {
        document.documentElement.classList.remove('aw-is-open');
        teaser.hidden = subscribed;
      };
      teaser.addEventListener('click', () => open(true));
      root.querySelectorAll('[data-aw-close]').forEach(button => button.addEventListener('click', dismiss));
      dialog.addEventListener('cancel', () => {
        remember({ dismissedUntil: Date.now() + (Number(root.dataset.dismissDays) || 14) * 86400000 });
        clearTimeout(timer);
      });
      dialog.addEventListener('close', onClose);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
      });
      const autoOpen = () => {
        if (!root.isConnected || wasAutoOpened) return;
        const typing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        if (!typing && open()) { wasAutoOpened = true; return; }
        if (++retries < 15) timer = setTimeout(autoOpen, 2000);
      };
      teaser.hidden = subscribed;
      if (preview || (submittedHere && result)) {
        open(true);
      } else if (!designMode && root.dataset.autoShow === 'true' && !subscribed && !(memory.dismissedUntil > Date.now())) {
        timer = setTimeout(autoOpen, Math.max(1, Number(root.dataset.delay) || 10) * 1000);
      }
      const unload = event => {
        if (!event.target.contains(root)) return;
        clearTimeout(timer);
        dialog.close();
        document.documentElement.classList.remove('aw-is-open');
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
